import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";
import {update} from "../../../app/setters/update.js";

export const useProsbaAnulujProjekt = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data) => update(`/${MAIN_REJESTR_API_SHORT}/prosba-anuluj`, data),
        onSettled: async () => {
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`lista_projektow__/rejestr/lista`),
            });
        },
        onSuccess: ({message}) => {
            toast.success(message)
        },
        onError: (error) => {
            toast.error(error?.message || 'Wystąpił błąd')
        }
    });
};
